export const MAX_TOTAL_SIZE = 10 * 1024 * 1024;
// 5 MB limit for email direct uploads; attachment uploads use 25 MB defined in PCreateAttachment/GeneralTab
export const MAX_FILE_SIZE = 5 * 1024 * 1024;
export const WARN_TOTAL_SIZE = 7 * 1024 * 1024;

export type SizeStatus = "ok" | "warning" | "error";

export function getSizeStatus(totalBytes: number): SizeStatus {
  if (totalBytes >= MAX_TOTAL_SIZE) return "error";
  if (totalBytes >= WARN_TOTAL_SIZE) return "warning";
  return "ok";
}

export function validateFileUpload(
  file: File,
  currentTotalBytes: number
): { valid: boolean; error?: string } {
  if (file.size > MAX_FILE_SIZE) return { valid: false, error: "fileTooLarge" };
  if (currentTotalBytes + file.size > MAX_TOTAL_SIZE)
    return { valid: false, error: "totalSizeExceeded" };
  return { valid: true };
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
